module.exports = __webpack_public_path__ + "static/media/rock8-01.90cf2341.svg";